<div id="user-menu">
    <div class="dropdown-menu-extra" role="document">
        <div class="user-menu-box">
            <div class="u-menu-body">
                <div class="user-row">
                    <div class="user-info">
                        <h4 id="">
                            <span>{{user?.firstName + ' ' + user?.lastName}}</span>
                        </h4>
                        <div class="user-email">{{user?.email}}</div>
                    </div>
                </div>
            </div>
            <div class="viewAsOption" *ngIf="showViewAsOption$ | async">
                <div class="header">View as :</div>
                <div class="u-menu-footer signin-user-info">
                    <span class="role-name"><a class="" (click)="activateClientManagerMode()">Client Manager</a></span>
                </div>

                <div class="u-menu-footer signin-user-info client-sme-menu">
                    <span class="role-name">
                        <a class="" (click)="getAvailableSmeUsers(); $event.stopPropagation()">Client SME</a>
                    </span>
                </div>
            </div>
            <div (click)="$event.stopPropagation()" *ngIf="!isSignInAsClientFlag">
                <div (click)="revertClientSME(); $event.stopPropagation()">
                    <i
                        class="far fa-arrow-left back-arrow"
                        aria-hidden="true">
                    </i>View as Client SME
                </div>
                <ul class="list-style">
                    <div class="input-with-icon-clientSME">
                        <input class="search-box-custom-clientSME" placeholder="Search SME" type="text" value=""
                            aria-autocomplete="none" required aria-expanded="false" data-clientsmeinput="clientsmeinput"
                            (input)="onSearchSMEs($event.target.value)" />
                        <i class="fa-solid fa-search input-with-icon" aria-hidden="true"></i>
                    </div>
                    <div class="u-menu-footer clientsmedropdown-body">
                        <li *ngFor="let sme of filteredSMEs">
                            <label class="filter-label-sme" style="margin-top: 0">
                                <span class="role-name"><a class="client-sme-color"
                                        (click)="activateViewAsSME(sme.userId)">{{sme ?
                                        sme.displayName : ''}}</a></span>
                            </label>
                        </li>
                    </div>

                </ul>
            </div>
            <div class="u-menu-footer">
                <a class="danger logOut" id="linkLogout" (click)="logout()"><i
                        class="fal fa-sign-out"></i>&nbsp;Logout</a>
            </div>
        </div>
    </div>
</div>
